export default __webpack_public_path__ + "static/media/images-2.1bc27146.jpg";